<script lang="ts">
import { onMount } from "svelte";
import { navigate, useParams } from "svelte-navigator";
import { Alert, Button, Form, FormGroup, Icon, Input, InputGroup, InputGroupText, Label } from "sveltestrap";
import { carService, clientsService, parkingService, parkingStorageService, zonesService } from "../services";
import type { Coords } from "../interfaces";
import type { Client } from "../Model/Client";
import { isLoggedIn, getCurrentUser } from "../services/session";
import type { Zone } from "../Model/Zone";
import { Parking } from "../Model/Parking";
import { v4 as uuidv4 } from 'uuid';
import { Car } from "../Model/Car";
import ClientBar from "../components/ClientBar.svelte";
import Footer from "../components/Footer.svelte";

let coords: Coords;
let client: Client;
let zones: Zone[];
let zoneAutoSelect: string = undefined;
let showAlert = false;
let saving = false;
let parking: Parking = new Parking(
  uuidv4(),
  '',
  '',
  '',
  '',
  new Date(),
  '',
  coords
)

const params = useParams();
const today = new Date();
const day = new Intl.DateTimeFormat('es-ES', { weekday: 'long' }).format(today);
const month = new Intl.DateTimeFormat('es-ES', { month: 'short' }).format(today);
const date = day + ' ' + today.getDay() + ' ' + month;
const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
let timeToPublic = time + ' ' + date;


onMount(async () => {
  if (!isLoggedIn()) {
    navigate('/login')
    return;
  }

  if ($params.plate) {
    parking.plate = $params.plate
  }

  parking.contactPhone = await clientsService.getClientPhone();

  client = getCurrentUser()

  navigator.geolocation.getCurrentPosition(successLocation, errorLocation, {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  });

  getZones()
})

function successLocation(pos) {
  coords = {
    lon : pos.coords.longitude,
    lat : pos.coords.latitude
  }

  selectZoneByGeolocation();
};

function errorLocation(err) {
  coords = {
    lon : 0,
    lat : 0
  }
  console.warn('ERROR(' + err.code + '): ' + err.message);
};


async function getZones(){
  zones = await zonesService.getZones();

  selectZoneByGeolocation()
}

function selectZoneByGeolocation(){
  
  if(!zones || !coords) return;

  const zone = zones.find(zone => zone.isInZone(coords));

  if (!zone){
    zoneAutoSelect = undefined;
    return;
  }

  zoneAutoSelect = zone.id
  
}


async function parkingCar(){
  saving = true;

  parking.zoneId = zoneAutoSelect;
  parking.email = client.email.value;
  parking.clientId = client.id.value;
  parking.coordinates = coords ? coords : null;

  if (parking.validate()) {
    showAlert = false;
    
    await parkingService.saveParking(parking);
    carService.saveCar(new Car(parking.plate, parking), client.id.value)
    clientsService.savePhone(parking.contactPhone)
    parkingStorageService.addParkingToMap(parking);

    navigate('/')
  }else{
    showAlert = true;
    saving = false;
  }
  
}


</script>

<style lang="scss">

  .control-html{
    position: relative;
    width: 100vw;
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: 450px;
    margin: auto;
    background-color: #BAD9FF;
  }

  .body-html {
      position: relative;
      height: 100%;
      padding-bottom: 40px;
      max-width: 360px;
      width: 100%;
      margin: auto;
  }

    .content-img{
      width: 100%;
      margin: 35px 0 35px 0;

      img{
        width: 30%;
        align-items: center;
        vertical-align: middle;
        max-width: 400px;
        align-self: center;
      }
    }

    .button-footer{
      width: 85%;
      margin: auto;
    

      :global(#button-parking-ok){
        width: 100%;
        display: block;
        background-color: #34A853;
        border-color: #34A853;
        min-height: 45px;
        font-size: 20px;
        font-weight: bold;
        border-radius: 10px;
      }
    }

    .content-html{
      width: 85%;
      background-color: #fff;
      padding: 15px;
      border-radius: 10px;
      margin: auto;

      .form-select{
        min-height: 50px;
        border-radius: 10px;
        color: #0E3CA5;
        border-color: #0E3CA5;
      }

      .font-notes{
        font-style: italic;
        font-size: 12px;
        font-weight: 200;
        margin-left: 15px;
      }

      :global(input){
        min-height: 50px;
        border-radius: 10px;
        color: #0E3CA5;
        border-color: #0E3CA5;
      }

      :global(input::placeholder){
        color: #0E3CA5; 
      }

      :global(label){
        font-weight: bold;
        font-size: 20px;
        color: #0E3CA5;
      }

      :global(#dateInputDisabled){
        background-color: #fff !important;
        color: #0E3CA5 !important;
        border-right: none;
        opacity: 0.5;
        border-color: #0E3CA5;
      }

      :global(#introPlateButton){
        background-color: #0E3CA5;
        border-top-right-radius: 15px !important;
        border-bottom-right-radius: 15px !important;
        border-color: #0E3CA5;
        font-weight: bold !important;
        min-width: 60px;
        font-size: 25px;
        color: #fff;
      }

      :global(#iconDisabled){
        background-color: #fff !important;
        color: #0E3CA5 !important;
        border-top-right-radius: 15px !important;
        border-bottom-right-radius: 15px !important;
        border-color: #0E3CA5;
        height: 50px !important;
        min-width: 60px;
        font-size: 25px;
        border-left: none;
        opacity: 0.5;
      }

      #introPlate{
        border-top-left-radius: 15px !important;
        border-bottom-left-radius: 15px !important;
        color: #0E3CA5 !important;

      }
      
    }

</style>



<div class="control-html">
  <ClientBar />
  <div class="content-img text-center">
    <img alt="" src="/img/car_icon.png"> 
  </div>
    <div class="body-html">
  
      <div class="content-html">
        <Form>
          <FormGroup>
            <Label for="exampleEmail">Datos del vehículo</Label>
            <InputGroup>
              <Input
                class="input-group-rd"
                type="text"
                id="introPlate"
                placeholder="Introduzca la matrícula"
                bind:value={parking.plate}
              />
              <Button id="introPlateButton" color=light><Icon name="camera-fill"/></Button>
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label for="exampleEmail">Datos del aparcamiento</Label>
            <InputGroup>
              <Input
                class="input-group-rd mb-2"
                type="text"
                id="dateInputDisabled"
                bind:value={timeToPublic}
                disabled
              />
              <InputGroupText id="iconDisabled"><Icon name="lock-fill" /></InputGroupText>
            </InputGroup>
  
            {#if zones}
              <select class="form-select" bind:value={zoneAutoSelect}>
                <option value="{undefined}">Zona</option>
                {#each zones as zone, index}
                    <option value={zone.id}>
                        {zone.name}
                    </option>
                {/each}
              </select>
            {/if}
            {#if coords}
              <span class="font-notes" >{coords.lat}, {coords.lon}</span>
            {/if}
          </FormGroup>
          <FormGroup>
            <Label for="exampleEmail">Nº Móvil</Label>
            <Input
              class="input-group-rd"
              type="tel"
              id="introPlate"
              placeholder="Introduzca su número de movil"
              bind:value={parking.contactPhone}
            />
          </FormGroup>
          {#if showAlert}
            <Alert color="warning">
              Faltan campos por rellenar
            </Alert>
          {/if}

        </Form>
      </div>

      <div class="button-footer mt-4">
        <!-- <Button id="button-parking-ko" type="button" color=primary on:click={() => navigate('/')}>Inicio</Button> -->
        <Button id="button-parking-ok" type="button" color=primary on:click={parkingCar} bind:disabled={saving}>Aparcar vehículo</Button>
      </div>
    </div>
  
</div>

<Footer/>